import { render } from "./License.vue?vue&type=template&id=5e04b290&scoped=true"
import script from "./License.vue?vue&type=script&lang=js"
export * from "./License.vue?vue&type=script&lang=js"

import "./License.vue?vue&type=style&index=0&id=5e04b290&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e04b290"

export default script